import { useState } from "react";
import { FileField, FileInput, ImageInput } from "react-admin";
import { useFormContext } from "react-hook-form";

const UploadFile = ({ name, label }) => {
  const form = useFormContext();
  const [fileUrl, setFileUrl] = useState("");
   const token = JSON.parse(localStorage.getItem("token"));

  const upload = async (e) => {
    var formData = new FormData();
    formData.append("file", e);
    let response = await fetch(
      // `https://api.mahsool.sd` + "/admin/knowledgemanager/upload",
      // `http://localhost:3060` + "/admin/knowledgemanager/upload",
      `${process.env.REACT_APP_URL}/admin/knowledgemanager/upload`,
      {
        method: "POST",
        headers: {"Authorization": `Bearer ${token}`},
        body: formData,
      }
    ).then((res) => res.json());

    setFileUrl(response.url);

    form.setValue(`${name}`, response.url);
  };
  //
  return (
    <FileInput
      source={`_file`}
      onChange={(e) => upload(e)}
      multiple={false}
      accept=".txt ,.pdf"
    >
      <div
        className={` bg-green-400 w-fit p-2 rounded ${
          fileUrl ? "block" : "hidden"
        }`}
      >
        Uploaded Successfully, Ready to save
      </div>
    </FileInput>
  );
};

export default UploadFile;
